<template>
  <div>
    <img src="../assets/guanwang.png" alt="">
   <FooterBot></FooterBot>
  </div>
  </template>
  
  <script>
import FooterBot from '../components/FooterBot.vue';
  
  export default {
    components: {
      FooterBot
    },
  };
  </script>
  <style scoped>
  img{
    width:100%;
  }

  </style>
  